import * as React from 'react';
import { Modal, ModalFooter, toast } from '@grandvisionhq/common';
import { CheckboxWithLabel, Util } from '@grandvisionhq/forms';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import { TitleWithIcon } from '../../components/TitleWithIcon/TitleWithIcon.js';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '../../models/cart/cart-state.js';
import '../../models/checkout-settings.js';
import { ShippingMethod } from '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import { useFormSlot } from '../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../state.js';
import { updateShippingDetails, toggleDeliveryAddress } from '../../StepShipping/actions.js';
import { getShippingDetails, isDeliveryFormEnabled, getShippingData, getSelectedShippingMethod } from '../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import { isDelivery, isDeliveryExpress } from '../../utils/shipping-method.js';
import 'history';
import '../../utils/has-cart-errors.js';

const hasAddressData = (addressData)=>Boolean(addressData && !Object.values(addressData).every((x)=>x === null || x === ''
    ))
;
const getCountry = (addressData)=>{
    var ref;
    return addressData && ((ref = addressData.formState.country) === null || ref === void 0 ? void 0 : ref.value) || '';
};
const EditableAddressesSummary = ({ labels  })=>{
    var ref, ref1, ref2, ref3, ref4;
    const checkoutSettings = useCheckoutSettings();
    const shippingData = useSelector(getShippingDetails);
    const isDeliveryAddressEnabled = useSelector(isDeliveryFormEnabled);
    const deliveryAddressData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.deliveryAddress;
    const [billingAddressFormData, setBillingAddressFormData] = React.useState(()=>{
        if (shippingData === null || shippingData === void 0 ? void 0 : shippingData.billingAddress) {
            return {
                formState: shippingData.billingAddress.formData,
                formName: ShippingObjectTypes.BillingAddress,
                formValid: true
            };
        }
        return {
            formState: {},
            formName: '',
            formValid: true
        };
    });
    const [deliveryAddressFormData, setDeliveryAddressFormData] = React.useState(()=>{
        if ((shippingData === null || shippingData === void 0 ? void 0 : shippingData.deliveryAddress) && Boolean(deliveryAddressData)) {
            return {
                formState: shippingData.deliveryAddress.formData,
                formName: ShippingObjectTypes.DeliveryAddress,
                formValid: true
            };
        }
        return {
            formState: {},
            formName: '',
            formValid: true
        };
    });
    const { billingAddress: billingAddressForm , deliveryAddress: deliveryAddressForm  } = useFormSlot({
        onChange: (formData)=>{
            if (formData.formName === 'billingAddress') {
                setBillingAddressFormData(formData);
            }
            if (formData.formName === 'deliveryAddress') {
                setDeliveryAddressFormData(formData);
            }
        }
    });
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const billingAddressData = (ref1 = useSelector(getShippingData)) === null || ref1 === void 0 ? void 0 : ref1.billingAddress;
    const selectedShippingMethod = (ref2 = useSelector(getSelectedShippingMethod)) === null || ref2 === void 0 ? void 0 : ref2.method;
    const isDelivery$1 = isDelivery(selectedShippingMethod);
    const isDeliveryExpress$1 = isDeliveryExpress(selectedShippingMethod);
    const [addressesAreEqual, setAddressesAreEqual] = React.useState(!Boolean(deliveryAddressData));
    const isDeliveryAddressRequired = selectedShippingMethod === ShippingMethod.Delivery && ((ref3 = checkoutSettings.shipping) === null || ref3 === void 0 ? void 0 : ref3.requiredShippingCountry) && getCountry(billingAddressFormData) && checkoutSettings.shipping.requiredShippingCountry !== getCountry(billingAddressFormData);
    React.useEffect(()=>{
        setAddressesAreEqual(!Boolean(deliveryAddressData));
    }, [
        deliveryAddressData
    ]);
    React.useEffect(()=>{
        if (isDeliveryAddressRequired && !Boolean(deliveryAddressData)) {
            setAddressesAreEqual(false);
        }
    }, [
        deliveryAddressData,
        isDeliveryAddressRequired
    ]);
    const hasBillingAddressData = hasAddressData(billingAddressData);
    const hasDeliveryAddressData = hasAddressData(deliveryAddressData);
    const hasData = hasBillingAddressData || hasDeliveryAddressData;
    const AddressesSummarySlot = Slots.addresses;
    let isPickupOrder = false;
    if (!isDelivery$1 && !isDeliveryExpress$1) {
        isPickupOrder = true;
    }
    if (!AddressesSummarySlot && hasData) {
        console.error('This opco is misconfigured. It has addresses data, but no addresses summary card setup.');
    }
    if (!AddressesSummarySlot || !hasData) {
        return null;
    }
    const handleSubmit = ()=>{
        if (!(billingAddressFormData === null || billingAddressFormData === void 0 ? void 0 : billingAddressFormData.formValid) || !addressesAreEqual && !(deliveryAddressFormData === null || deliveryAddressFormData === void 0 ? void 0 : deliveryAddressFormData.formValid)) {
            Util.focusToTopErrorFieldOnScreen();
        } else {
            billingAddressFormData && dispatch(updateShippingDetails({
                form: billingAddressFormData
            }));
            deliveryAddressFormData && dispatch(updateShippingDetails({
                form: deliveryAddressFormData
            }));
            dispatch(toggleDeliveryAddress({
                enabled: !addressesAreEqual
            }));
            setIsModalOpen(false);
        }
    };
    const handleModalClose = ()=>{
        if (!isDeliveryAddressEnabled && !addressesAreEqual) {
            setAddressesAreEqual(true);
        }
        setIsModalOpen(false);
    };
    const handleAddressToggle = ()=>{
        if (isDeliveryAddressRequired) {
            toast.failed('checkout.address.requiredShippingCountry.errorMessage');
        } else {
            setAddressesAreEqual(!addressesAreEqual);
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: handleModalClose,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref4 = labels.editModal) === null || ref4 === void 0 ? void 0 : ref4.save,
            onCta: handleSubmit,
            onCancel: handleModalClose
        })
    }, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "billing",
        label: labels.generic.title
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, billingAddressForm), !isPickupOrder && /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        id: "usingDeliveryAddress",
        value: "usingDeliveryAddress",
        checked: addressesAreEqual,
        onChange: handleAddressToggle,
        className: "billing-and-delivery-form__checkbox",
        label: labels === null || labels === void 0 ? void 0 : labels.differentDeliveryAddress
    }), !addressesAreEqual && !isPickupOrder && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "location-pin",
        label: labels.generic.deliveryAddress
    }), deliveryAddressForm)), hasData && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AddressesSummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: {
            isAddressesEqual: !hasDeliveryAddressData,
            isPickupOrder,
            billingAddress: billingAddressData,
            deliveryAddress: deliveryAddressData
        }
    })));
};

export { EditableAddressesSummary, EditableAddressesSummary as default };
//# sourceMappingURL=EditableAddressesSummary.js.map
